import { render } from "./BidNew.vue?vue&type=template&id=349ad750&scoped=true&ts=true"
import script from "./BidNew.vue?vue&type=script&lang=ts"
export * from "./BidNew.vue?vue&type=script&lang=ts"

import "./BidNew.vue?vue&type=style&index=0&id=349ad750&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349ad750"]])

export default __exports__